import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-quill-text',
  templateUrl: './gb-quill-text.component.html',
  styleUrls: ['./gb-quill-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbQuillTextComponent {
  @Input({ required: true }) html!: string
  @Input() safeType: 'html' | 'trustedHtml' = 'html'
}
